import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

//#region src/client/make-flag-provider.ts
const launchDarklyAnonContext = {
	kind: "user",
	anonymous: true
};
/**
* Builds the LaunchDarkly React provider. Pass `localBaseUrl` in dev mode to poll a
* local fixture server serving the LaunchDarkly client-side polling protocol; when
* it is unset the SDK behaves exactly as the default.
*/
const makeFlagProvider = async (clientId, application, localBaseUrl) => {
	return await asyncWithLDProvider({
		context: launchDarklyAnonContext,
		clientSideID: clientId,
		options: {
			application,
			allAttributesPrivate: true,
			...localBaseUrl ? buildLocalOptions(localBaseUrl) : {}
		}
	});
};
const buildLocalOptions = (baseUrl) => ({
	baseUrl,
	streamUrl: baseUrl,
	eventsUrl: baseUrl,
	streaming: false,
	sendEvents: false,
	fetchGoals: false,
	diagnosticOptOut: true
});

//#endregion
export { makeFlagProvider };